import { graphql } from "@/graphql/codegen"

graphql(`
  fragment InvoiceExpenseLineBaseFields on InvoiceExpenseLine {
    invoiceExpenseLineId
    invoiceId
    glAccountId
    amount
    description
  }
`)

graphql(`
  fragment InvoiceBaseFields on Invoice {
    invoiceId
    referenceNumber
    invoiceNumber
    vendorCompanyId
    invoiceDate
    accountingPeriod
    dueDate
    scheduledPayDate
    invoiceType
    status
    paymentMethod
    printedCheck
    duplicateWarningBypassed
    as400ApproveSyncStatus
    as400PaidSyncStatus
    as400VoidSyncStatus
    as400ReversalSyncStatus
    paidDate
    createdOn
    createdBy
    updatedBy
    expenseLines {
      ...InvoiceExpenseLineBaseFields
    }
  }
`)

graphql(`
  fragment InvoiceListExpandedRowFields on Invoice {
    ...InvoiceBaseFields
    lockingPayFile {
      payFileId
      referenceNumber
      status
    }
    vendorCompany {
      companyId
      name
      publicId
      externalSystemId
      types
      billingLocation {
        locationId
        address1
        address2
        city
        regionIsoCode
        postalCode
        countryIsoCode
        country {
          name
        }
      }
    }
    createdByUser {
      firstName
      lastName
      name
    }
    updatedByUser {
      firstName
      lastName
      name
    }
  }
`)
